export const optionsBar = {
    chart: {
        type: "bar",
        height: 350,
        stacked: true,
        zoom: {
            enabled: false,
        },
    },
    plotOptions: {
        bar: {
            borderRadius: 4,
            horizontal: false,
            distributed: true,
            columnWidth: "50px",
        },
    },
    dataLabels: {
        enabled: false,
    },
    colors: [
        "rgba(127, 0, 255, 0.3)",
        "rgba(75, 192, 192, 0.6)",
        "rgba(255, 99, 132, 0.6)",
        "rgba(54, 162, 235, 0.6)",
        "rgba(255, 205, 86, 0.6)",
        "rgba(255, 69, 0, 0.6)",
        "rgba(241, 2, 2, 0.5)",
        "rgba(60, 179, 113, 0.6)",
        "rgba(241, 2, 2, 0.3)",
        "rgba(127, 0, 255, 0.3)",
        "rgba(75, 192, 192, 0.6)",
        "rgba(128, 0, 255, 0.6)",
    ],
}

const barColorsByCompany: Record<string, string[]> = {
    BSG: [
        'rgba(67, 173, 78, 0.6)',
        'rgba(75, 192, 192, 0.6)',
    ],
    BBQ: [
        'rgba(30, 64, 175, 0.6)',
        'rgba(14, 165, 233, 0.6)',
    ],
};

export const getBarColorsByCompany = (companyKey?: string) =>
    barColorsByCompany[companyKey ?? ''] ?? barColorsByCompany.BSG;